import { render, staticRenderFns } from "./wtr-slide-info.vue?vue&type=template&id=260bf4f2&scoped=true&"
import script from "./wtr-slide-info.vue?vue&type=script&lang=js&"
export * from "./wtr-slide-info.vue?vue&type=script&lang=js&"
import style0 from "./wtr-slide-info.vue?vue&type=style&index=0&id=260bf4f2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260bf4f2",
  null
  
)

export default component.exports